import React, { useState, useEffect, useLayoutEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styles from './DetailModal.module.css'
import {
  Button,
  Divider,
  Flex,
  message,
  Modal,
  Tooltip,
  Image,
  Tag,
} from 'antd'
import classNames from 'classnames'
import { addResReviewNumRequest, downloadFileRequest } from '../ResourceLibApi'
import { getSixMathRandom } from '../../../../util/handMath'
import Cookies from 'js-cookie'
export default function DetailModal(props) {
  //   const count = useSelector(selectCount);
  const dispatch = useDispatch()
  const [contentHeight, setContentHeight] = useState(0)

  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    setTimeout(() => {
      if (document.getElementById('detailModal')) {
        let height = document.getElementById('detailModal').clientHeight - 110
        setContentHeight(height)
      }
    }, 100)
    if(props.visible){
      addReviewNum(props.currentResource.code)
    }
    return () => {
      // console.log('组件即将卸载');
    }
  }, [props.visible]) // 空数组意味着这个 effect 只会在组件挂载时执行一次
  const addReviewNum = (code) => {
    addResReviewNumRequest(code, (data) => {
      if (data.ret == 1) {
        let tempResource = {...props.currentResource}
        tempResource.liulan_num = parseInt(tempResource.liulan_num) + 1
        props.setCurrentResource(tempResource)
      } else {
        message.warning(data.msg)
      }
    })
  }
  function downLoadFile(e) {
    let timestamp = new Date().getTime()
    let random = getSixMathRandom()
    let jilu_code = timestamp + random+Cookies.get("username")
    downloadFileRequest(props.currentResource.code, jilu_code, (data) => {
      if (data.ret == 1) {
        const a = document.createElement('a');
        a.href = data.data.ziyuan_url;
        // a.download = props.currentResource.name+'.pdf';
        // 第二步：触发下载
        a.click();
        let tempResource = {...props.currentResource}
        tempResource.xiazai_num = parseInt(tempResource.xiazai_num) + 1
        props.setCurrentResource(tempResource)
        message.success('下载成功')
      } else {
        message.warning(data.msg)
      }
    })
  }
  return (
    <Modal
      title="教学资料详情"
      open={props.visible}
      onCancel={props.handleCancel}
      width={710}
      footer={null}
    >
      <div className={styles.background}>
        <div className={styles.leftBox} id="detailModal">
          <Image
            width={230}
            height={125}
            alt="头图"
            style={{ objectFit: 'cover', borderRadius: 8 }}
            src={props.currentResource.fengmian_url}
          />
          {props.currentResource.hasOwnProperty('nianjiList') && (
            <div className={styles.subjectTag}>
              {props.currentResource.nianjiList.map((item, index) => {
                return (
                  <Tag
                    color={item.color}
                    variant={'solid'}
                    style={{ marginTop: 10,zIndex:1000 }}
                  >{item.label}</Tag>
                )
              })}
              {props.currentResource.xuekeList.map((item, index) => {
                return (
                  <Tag
                    color={item.color}
                    variant={'solid'}
                    style={{ marginTop: 10,zIndex:1000 }}
                  >{item.label}</Tag>
                )
              })}
            </div>
          )}
          <p style={{ fontSize: 12 }}>下载信息</p>
          <div className={styles.desBox}>
            <span className={styles.leftDes}>所需积分</span>
            <span className={styles.rightDes} style={{ color: '#ecb75a' }}>
              {props.currentResource.jifen}积分
            </span>
          </div>
          {/* <div className={styles.desBox}>
            <span className={styles.leftDes}>文件数量</span>
            <span className={styles.rightDes}>10个文件</span>
          </div> */}
          <div className={styles.desBox}>
            <span className={styles.leftDes}>文件大小</span>
            <span className={styles.rightDes}>{props.currentResource.size}MB</span>
          </div>
          <div className={styles.desBox}>
            <span className={styles.leftDes}>上传日期</span>
            <span className={styles.rightDes}>{props.currentResource.ctime ? props.currentResource.ctime.substring(0,10) : ''}</span>
          </div>
          <Button
            type="primary"
            style={{ width: '100%', marginTop: 20, marginBottom: 20 }}
            onClick={downLoadFile}
          >
            立即下载
          </Button>
        </div>
        <div className={styles.rightBox}>
          <span style={{ fontSize: 14 }}>{props.currentResource.title}</span>
          <span
            style={{
              fontSize: 12,
              marginTop: 10,
              color: 'rgba(9, 27, 61, 0.6)',
            }}
          >
            {props.currentResource.xiazai_num}次下载 &nbsp;&nbsp;{props.currentResource.liulan_num}人浏览
          </span>
          <div className={styles.contentDesc}>
            <span style={{ fontSize: 14, color: '#000' }}>内容介绍</span>
            &nbsp;&nbsp;
            {props.currentResource.xiangqing_url==""||props.currentResource.xiangqing_url=="null"?null:
            <a
              href={props.currentResource.xiangqing_url}
              target="_blank"
              style={{ fontSize: 12 }}
              rel="noopener noreferrer"
            >
              快速了解
            </a>
            }
          </div>
          <pre className={styles.desText} style={{ maxHeight: contentHeight }}>
            {props.currentResource.jianjie}
          </pre>
        </div>
      </div>
    </Modal>
  )
}

